import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { Site } from '../../../../../common/constants/siteList'
import { ILocationParams } from '../../../../../common/reducers/reactRouterLocation'
import { getMinutesSecondsTime } from '../../../../../common/utils/time'

import ChevronRightIcon from '../../../../shared/components/icons/chevronRight'

import * as styles from './filtersRange.module.css'

interface IProps extends RouteComponentProps<any> {
  paramName: string
  name: string
  prefix?: string
  type?: string
  range?: any
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

interface IState {
  min: number | string | undefined
  max: number | string | undefined
}

const dataTypes: any = {
  time: {
    parser: getMinutesSecondsTime,
    resultType: 'string'
  },
  number: {
    parser: (value: string): number => parseFloat(value),
    resultType: 'number'
  }
}

class FiltersRange extends React.Component<IProps, IState> {
  private paramMin: string
  private paramMax: string
  private placeholder: any

  constructor(props: IProps) {
    super(props)
    const { locationParams, paramName, range } = props

    this.paramMin = `${paramName}_min`
    this.paramMax = `${paramName}_max`

    const min = locationParams && locationParams[this.paramMin]
    const max = locationParams && locationParams[this.paramMax]

    this.placeholder = {
      min: range.min,
      max: range.max
    }

    this.state = {
      min: this.parseValue(min),
      max: this.parseValue(max)
    }
  }

  public onRangeMinChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ min: event.target.value })
  }

  public onRangeMaxChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ max: event.target.value })
  }

  public onSubmit() {
    const { locationParams, history, makeSearchLink } = this.props

    const nextQuery = {
      ...locationParams,
      [this.paramMin]: `${this.parseValue(this.state.min)}`,
      [this.paramMax]: `${this.parseValue(this.state.max)}`
    }
    delete nextQuery.page

    if (!this.state.min) {
      delete nextQuery[this.paramMin]
    }

    if (!this.state.max) {
      delete nextQuery[this.paramMax]
    }

    history.push(makeSearchLink(nextQuery) + '#content')
  }

  public onEnter(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.onSubmit()
    }
  }

  public componentWillReceiveProps(nextProps: IProps) {
    const { locationParams, range } = nextProps

    if (
      locationParams[this.paramMin] !== undefined &&
      parseInt(locationParams[this.paramMin], 10) !== this.state.min
    ) {
      this.setState({
        min: this.parseValue(locationParams[this.paramMin]) || ''
      })
    }

    if (
      locationParams[this.paramMax] !== undefined &&
      parseInt(locationParams[this.paramMax], 10) !== this.state.max
    ) {
      this.setState({
        max: this.parseValue(locationParams[this.paramMax]) || ''
      })
    }

    this.placeholder = {
      min: range.min,
      max: range.max
    }
  }

  public render() {
    const defaultMin = this.state.min ? this.state.min.toString() : undefined
    const defaultMax = this.state.max ? this.state.max.toString() : undefined

    return (
      <div className={styles.inputsContainer}>
        <div className={styles.inputWrapper}>
          {this.getPrefix()}
          <input
            aria-label={`Minimum ${this.props.name}`}
            min="0"
            type="text"
            name={`Minimum ${this.props.name}`}
            className={styles.input}
            defaultValue={defaultMin}
            placeholder={this.placeholder.min}
            onChange={this.onRangeMinChange.bind(this)}
            onKeyPress={this.onEnter.bind(this)}
          />
        </div>
        <span className={styles.spacer}>-</span>
        <div className={styles.inputWrapper}>
          {this.getPrefix()}
          <input
            aria-label={`Maximum ${this.props.name}`}
            min="0"
            type="text"
            name={`Maximum ${this.props.name}`}
            className={styles.input}
            defaultValue={defaultMax}
            placeholder={this.placeholder.max}
            onChange={this.onRangeMaxChange.bind(this)}
          />
        </div>
        <button
          type="button"
          className={styles.buttonFilter}
          onClick={this.onSubmit.bind(this)}
        >
          <ChevronRightIcon width="8" height="12" />
        </button>
      </div>
    )
  }

  private parseValue(value: string | number | undefined): number | undefined {
    if (typeof value === 'undefined') {
      return undefined
    }

    const { type = 'number' } = this.props
    const result = dataTypes[type].parser(value)

    return dataTypes[type].resultType === typeof result ? result : 0
  }

  private getPrefix() {
    return this.props.prefix ? (
      <span className={styles.prefix}>{this.props.prefix}</span>
    ) : null
  }
}

export const FiltersRangeComponent = FiltersRange
export default withRouter(FiltersRange)
